.slider {
  display: flex;
  flex-direction: column;
  gap: var(--hs-spacing-2);
  min-width: 0;
}
.head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--hs-spacing-3);
}
.label {
  font: var(--hs-type-label);
  letter-spacing: var(--hs-label-ls);
  color: var(--hs-color-text-primary);
}
.value {
  font: var(--hs-type-caption);
  letter-spacing: var(--hs-caption-ls);
  color: var(--hs-color-text-secondary);
  font-variant-numeric: tabular-nums;
}
/* The name and the value for assistive technology only, where a heading names the setting. */
.hiddenLabel {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

/* The track fills up to the thumb: --hs-slider-fill is set by the component. */
.input {
  width: 100%;
  height: 24px;
  margin: 0;
  background: transparent;
  cursor: pointer;
  appearance: none;
}
.input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.input::-webkit-slider-runnable-track {
  height: 6px;
  border-radius: var(--hs-radius-full);
  background: linear-gradient(
    to right,
    var(--hs-color-primary-default) var(--hs-slider-fill),
    var(--hs-color-bg-subtle) var(--hs-slider-fill)
  );
}
.input::-moz-range-track {
  height: 6px;
  border-radius: var(--hs-radius-full);
  background: var(--hs-color-bg-subtle);
}
.input::-moz-range-progress {
  height: 6px;
  border-radius: var(--hs-radius-full);
  background: var(--hs-color-primary-default);
}
.input::-webkit-slider-thumb {
  width: 20px;
  height: 20px;
  margin-top: -7px;
  border: 2px solid var(--hs-color-bg-surface);
  border-radius: var(--hs-radius-full);
  background: var(--hs-color-primary-default);
  box-shadow: var(--hs-shadow-md);
  appearance: none;
}
.input::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border: 2px solid var(--hs-color-bg-surface);
  border-radius: var(--hs-radius-full);
  background: var(--hs-color-primary-default);
  box-shadow: var(--hs-shadow-md);
}
.input:focus-visible {
  outline: none;
}
.input:focus-visible::-webkit-slider-thumb {
  box-shadow: var(--hs-focus-lavender);
}
.input:focus-visible::-moz-range-thumb {
  box-shadow: var(--hs-focus-lavender);
}
